export default __webpack_public_path__ + "static/media/wallet-connect.488dc369.svg";